import "core-js/modules/es.object.keys.js";
//@ts-ignore
import { Modals } from "@customTypes/Modals";
import { defineStore } from "pinia";
import { ref } from "vue";
export var useModalStore = defineStore("modalStoreId", function () {
  //State
  var showModal = ref(Modals.noModal);
  //actions
  var setShowModal = function setShowModal(newValue) {
    showModal.value = newValue;
  };
  function openAndReturnTo(data) {
    var fromModal = data.fromModal,
      toModal = data.toModal,
      payload = data.payload;
    localStorage.setItem("returnTo", JSON.stringify({
      fromModal: fromModal
    }));
    localStorage.setItem("modalPayload", JSON.stringify(payload));
    showModal.value = toModal;
  }
  var openModalOnPageReload = function openModalOnPageReload() {
    var returnToJSON = localStorage.getItem("returnTo");
    localStorage.removeItem("returnTo");
    if (!returnToJSON) return;
    var isGoogleLogin = localStorage.getItem("isGoogleLogin");
    localStorage.removeItem("isGoogleLogin");
    var payloadObj = JSON.parse(returnToJSON);
    if (isGoogleLogin) showModal.value = payloadObj.fromModal;
  };
  return {
    showModal: showModal,
    setShowModal: setShowModal,
    openAndReturnTo: openAndReturnTo,
    openModalOnPageReload: openModalOnPageReload
  };
});